import React from "react";
import { cn } from "../lib/Utils";

export function TournamentLegend({ teamColors }) {
    // Obtenemos los IDs de equipo de las keys de teamColors
    const teamIds = Object.keys(teamColors);

// Render the legend for the tournament, showing team colors and statuses
    return (
        <div className="mt-4 rounded-lg bg-white p-4 shadow-md">
            <h4 className="text-sm font-semibold mb-3">Legend</h4>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
                {teamIds.map((teamId, idx) => (
                    <div key={teamId} className="flex items-center">
                        <div
                            className={cn(
                                "w-4 h-4 rounded-full mr-2",
                                `legend-${teamColors[teamId]}`
                            )}
                        ></div>
                        <span>Team {idx + 1} win</span>
                    </div>
                ))}
                <div className="flex items-center">
                    <div className="w-4 h-4 bg-gray-200 rounded-full mr-2"></div>
                    <span>Hole not decided</span>
                </div>
            </div>
        </div>
    );
// Where span teamId is the name of the team, you can replace it with a name if you have a mapping(teamId => name)
}
